module.exports = __webpack_public_path__ + "static/media/cardbg2.7868817a.jpg";